import { ProductOverlay } from '#app/routes/mocra+/_form+/components/products/overlay.tsx'
import { type ProductDraft } from '#app/routes/mocra+/_form+/components/products/types.ts'

type Props = {
	readonly open: boolean
	readonly onOpenChange: (open: boolean) => void
	readonly onSubmit: (draft: ProductDraft) => void
	readonly initialValue: ProductDraft
	readonly title?: string
	readonly description?: string
	readonly submitLabel?: string
	readonly cancelLabel?: string
	readonly onCancel?: () => void
	readonly onClosed?: () => void
}

export function ProductEditOverlay({
	open,
	onOpenChange,
	onSubmit,
	initialValue,
	title,
	description,
	submitLabel,
	cancelLabel,
	onCancel,
	onClosed,
}: Props) {
	return (
		<ProductOverlay
			mode="edit"
			open={open}
			onOpenChange={onOpenChange}
			onSubmit={onSubmit}
			initialValue={initialValue}
			title={title}
			description={description}
			submitLabel={submitLabel}
			cancelLabel={cancelLabel}
			onCancel={onCancel}
			onClosed={onClosed}
		/>
	)
}
